import { useEffectOnce } from "react-use";
import { toast } from "sonner";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { validation } from "@/config";
import { conversion } from "./conversion.variants";
import { postConversion } from "@/services";

export type UseConversionProps = {
  building: string;
};

const schema = z.object({
  origin: z.string().min(1, { message: validation.required }),
  building: z.string().min(1, { message: validation.required }),
  name: z
    .string()
    .min(1, { message: validation.required })
    .transform((val) =>
      val.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
    ),
  email: z
    .email({ message: validation.email })
    .transform((val) => val.toLowerCase()),
  phone: z.string().min(1, { message: validation.required }),
  contact_preference: z.string().min(1, { message: validation.required }),
});

export type ConversionSchema = z.infer<typeof schema>;

export const useConversion = (props: UseConversionProps) => {
  const { building } = props;
  const styles = conversion();

  const form = useForm<ConversionSchema>({
    resolver: zodResolver(schema),
  });

  useEffectOnce(() => {
    form.setValue("origin", "landing-page");
    form.setValue("building", building);
  });

  const onSubmit: SubmitHandler<ConversionSchema> = async (data) => {
    try {
      const res = await postConversion(data);

      if (!res.success) {
        toast.error(res.message || "Ocorreu um erro ao enviar seus dados.");
        return;
      }

      toast.success(res.message || "Enviado com sucesso!");
      form.reset();
    } catch (error) {
      console.error(error);
      toast.error("Ocorreu um erro ao enviar seus dados.");
    }
  };

  return {
    styles,
    form,
    onSubmit,
  };
};
